import { render } from "./LearningBox.vue?vue&type=template&id=6b73a630"
import script from "./LearningBox.vue?vue&type=script&lang=js"
export * from "./LearningBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__